export const FETCH_PERSONNEL = "FETCH_PERSONNEL";
export const LOADING = "LOADING";
export const CREATE_PERSONNEL = "CREATE_PERSONNEL";
export const UPDATE_PERSONNEL = "UPDATE_PERSONNEL";
export const DELETE_PERSONNEL = "DELETE_PERSONNEL";
export const ERRORS = "ERRORS";
export const SAVING = "SAVING";
export const SIDE_FETCH = "SIDE_FETCH";
export const FETCH_SINGLE_PERSONNEL = "FETCH_SINGLE_PERSONNEL";
